<template>
  <my-case-header :title="hasQuarterlyItems ? 'Your Quarterly Rentals' : 'What does Quarterly mean?'">
    <p class="small-text mb-0">
      <template v-if="wasSeasonalCapsuleRenter">
        Seasonal Capsule is now <b>Quarterly Rentals</b> and is accessible in your Case!
      </template>
      <template v-else-if="hasQuarterlyItems">
        Enjoy for 3 months. <br>Rental price applied if purchased.
      </template>
      <template v-else>
        A low-cost way to keep what you love — longer.
      </template>
    </p>
  </my-case-header>
</template>

<script setup>
import MyCaseHeader from '../../common/header/MyCaseHeader'
import { useQuarterlyRentalsStore } from '@/stores/quarterlyRentals'
import { storeToRefs } from 'pinia'

const quarterlyRentalsStore = useQuarterlyRentalsStore()
const { hasQuarterlyItems, wasSeasonalCapsuleRenter } = storeToRefs(quarterlyRentalsStore)
</script>
